import React, {
  useEffect,
  useState,
} from "react";

import {
  Link,
} from "react-router-dom";

import "./CouponBanner.css";

const coupons = [
  {
    text:
      "🌮 10% off at African Village - Mention GoOurHub",
  },
  {
    text:
      "🥙 Buy 2 Meals, Get 1 Free at Un Gwan Gway",
  },
  
  {
    text:
      "contact@goourhub.com for exclusive deals",
  },
];

/*
 * Pull a leading emoji off the text
 * so it can sit inside the icon chip.
 */
const EMOJI_RE =
  /^\s*(\p{Extended_Pictographic}\uFE0F?)\s*/u;

const splitIcon = (
  text
) => {
  const match =
    text.match(
      EMOJI_RE
    );

  if (match) {
    return {
      icon:
        match[1],

      rest:
        text.slice(
          match[0].length
        ),
    };
  }

  return {
    icon: "🎁",
    rest: text,
  };
};

const formatDealText = (
  text
) => {
  const parts =
    text.split(
      /(signup|refer|contact@goourhub\.com)/g
    );

  return parts.map(
    (
      part,
      index
    ) => {
      if (
        part ===
        "signup"
      ) {
        return (
          <Link
            to="/partner-signup"
            key={index}
            className="promo-link"
          >
            {part}
          </Link>
        );
      }

      if (
        part ===
        "refer"
      ) {
        return (
          <Link
            to="/refer"
            key={index}
            className="promo-link"
          >
            {part}
          </Link>
        );
      }

      if (
        part ===
        "contact@goourhub.com"
      ) {
        return (
          <Link
            to="/contact"
            key={index}
            className="promo-link"
          >
            {part}
          </Link>
        );
      }

      return (
        <span
          key={index}
        >
          {part}
        </span>
      );
    }
  );
};

const CouponBanner = () => {
  const [
    currentIndex,
    setCurrentIndex,
  ] = useState(0);

  const [
    paused,
    setPaused,
  ] = useState(false);

  useEffect(() => {
    if (paused) {
      return undefined;
    }

    const rotate =
      window.setInterval(
        () => {
          setCurrentIndex(
            (
              previous
            ) =>
              (
                previous +
                1
              ) %
              coupons.length
          );
        },
        5000
      );

    return () =>
      window.clearInterval(
        rotate
      );
  }, [paused]);

  const {
    icon,
    rest,
  } = splitIcon(
    coupons[
      currentIndex
    ].text
  );

  return (
    <div
      className="promo"
      role="region"
      aria-label="Deals and offers"
      onMouseEnter={() =>
        setPaused(true)
      }
      onMouseLeave={() =>
        setPaused(false)
      }
      onFocus={() =>
        setPaused(true)
      }
      onBlur={() =>
        setPaused(false)
      }
    >
      <span
        className="promo__icon"
        aria-hidden="true"
      >
        {icon}
      </span>

      <div className="promo__body">
        <span className="promo__eyebrow">
          Featured deal
        </span>

        <p
          className="promo__text"
          key={currentIndex}
        >
          {formatDealText(
            rest
          )}
        </p>
      </div>

      <div
        className="promo__dots"
        aria-label="Featured deals"
      >
        {coupons.map(
          (
            _,
            index
          ) => (
            <button
              key={index}
              type="button"
              className={`promo__dot ${
                index ===
                currentIndex
                  ? "is-active"
                  : ""
              }`}
              onClick={() =>
                setCurrentIndex(
                  index
                )
              }
              aria-label={`Show deal ${
                index + 1
              } of ${
                coupons.length
              }`}
              aria-current={
                index ===
                currentIndex
                  ? "true"
                  : undefined
              }
            />
          )
        )}
      </div>
    </div>
  );
};

export default CouponBanner;